/*
 * @描叙: 表单验证规则 
 * @作者: hanlaifu 
 * @公司: 春梅信息 
 * @创建时间: 2019-01-23 17:03:01
 */

import stringUtils from '@/utils/stringUtils'

// 验证手机号
export const checkPhone = (rule, value, callback) => {
    if (!value) {
        return callback(new Error("请输入手机号码"));
    } else {
        if (stringUtils(value).isMobilePhone()) {
            callback();
        } else {
            return callback(new Error("手机号格式有误"));
        }
    }
};

// 验证电子邮箱
export const checkEmail = (rule, value, callback) => {
    if (!value) {
        return callback(new Error("请输入电子邮箱"));
    } else {
        if (stringUtils(value).isEmail()) {
            callback();
        } else {
            return callback(new Error("电子邮箱格式有误"));
        }
    }
};

// 验证身份证
export const checkIDnum = (rule, value, callback) => {
    if (!value) {
        return callback(new Error("请输入证件号码"));
    } else {
        if (stringUtils(value).isIDcard()) {
            callback();
        } else {
            return callback(new Error("身份证格式有误"));
        }
    }
};
